import 'devextreme/dist/css/dx.light.css';
import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { Spin, Row, Col, Card, List, Tag } from 'antd';
import { CompanySaleOderDetailsSelector, getCompanySaleOderDetails, getSalesByEmployeeGroupByDate } from '../../store/reducers/Report/companySaleOderDetails'
import DataDisplayWidget from '../../components/shared-components/DataDisplayWidget';
import { FileDoneOutlined, SyncOutlined, BarChartOutlined, ArrowUpOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Chart, Series, Label, CommonSeriesSettings, ArgumentAxis, Title } from 'devextreme-react/chart';
import PieChart, { Legend, Tooltip, Format, Connector, Export, } from 'devextreme-react/pie-chart';
import { ConstContext } from '../../store/context/constContext'
import Flex from '../../components/shared-components/Flex'
import NumberFormat from 'react-number-format';
import { TimeDataSelNotFromTo } from '../data/data'
import { Select, DatePicker, Space } from 'antd';
import moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;
const weekFormat = 'MM/DD';


const WeeklyRevenue = ({ pfrmDate, ptoDate }) => {
    const frmDate = new Date(pfrmDate)
    const toDate = new Date(ptoDate)
    const CompanySaleOderDetailsSelectors = useSelector(CompanySaleOderDetailsSelector)
    function customizeTooltip(pointInfo) {
        return {
            text: `${pointInfo.point.data.DateToolTip ? pointInfo.point.data.DateToolTip : pointInfo.argumentText}: ${pointInfo.valueText}`,
        };
    }
    return (<Card>
        <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={8}>

                <Flex className="h-100" flexDirection="column" justifyContent="between">
                    <div>
                        <h4 className="mb-0">Doanh thu</h4>
                        <span className="text-muted">{frmDate.getDate()} - {toDate.getDate()}/{toDate.getMonth() + 1}, {toDate.getFullYear()}</span>
                    </div>
                    <div className="mb-4">
                        <h1 className="font-weight-bold">${Intl.NumberFormat('en-US').format(CompanySaleOderDetailsSelectors.TotalTurnover)}</h1>
                        <p>Con số tổng thu nhập dựa trên phạm vi ngày được đưa ra ở trên.</p>
                    </div>
                </Flex>
            </Col>
            <Col xs={24} sm={24} md={24} lg={16}>
                <Chart
                    id="WeekChart"
                    title=""
                    dataSource={CompanySaleOderDetailsSelectors.SalesGroupByDate}
                >
                    <Series argumentField="DateFormat" />
                    <ArgumentAxis>
                        <Label
                            wordWrap="none"
                            overlappingBehavior={"stagger"}
                        />
                    </ArgumentAxis>
                    <Legend visible={false} />
                    <Tooltip enabled={true} customizeTooltip={customizeTooltip} >
                        <Format type="###,###,###" />
                    </Tooltip>
                </Chart>
            </Col>
        </Row>
    </Card>)
}
const DisplayDataSet = () => {
    const CompanySaleOderDetailsSelectors = useSelector(CompanySaleOderDetailsSelector)
    return (
        <>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DataDisplayWidget
                        icon={<FileDoneOutlined />}
                        value={new Intl.NumberFormat('en-US').format(Math.round(CompanySaleOderDetailsSelectors.TotalDelivery))}
                        title="Số đơn hàng"
                        color="cyan"
                        vertical={true}
                        avatarSize={55}
                    />
                    <DataDisplayWidget
                        icon={<BarChartOutlined />}
                        value={new Intl.NumberFormat('en-US').format(Math.round(CompanySaleOderDetailsSelectors.TotalQty)) + " Kg"}
                        title="Tổng sản lượng"
                        color="gold"
                        vertical={true}
                        avatarSize={55}
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DataDisplayWidget
                        icon={<SyncOutlined />}
                        value={"$" + new Intl.NumberFormat('en-US').format(Math.round(CompanySaleOderDetailsSelectors.TotalTurnover))}
                        title="Tổng doanh thu"
                        color="blue"
                        vertical={true}
                        avatarSize={55}
                    />
                    <DataDisplayWidget
                        icon={<UserSwitchOutlined />}
                        value={new Intl.NumberFormat('en-US').format(Math.round(CompanySaleOderDetailsSelectors.TotalBPOder))}
                        title="Tổng khách hàng"
                        color="volcano"
                        vertical={true}
                        avatarSize={55}
                    />
                </Col>
            </Row>
            <Row gutter={16}>

            </Row>
        </>
    )

}
const customWeekStartEndFormat = (value) =>
    `${moment(value).startOf('week').format(weekFormat)} ~ ${moment(value)
        .endOf('week')
        .format(weekFormat)}`;


const CompanySaleOderDetails = () => {
    const dispatch = useDispatch()
    const {
        isMobile,
    } = useContext(ConstContext)
    const bfFrmDate = moment().startOf('week');
    const CompanySaleOderDetailsSelectors = useSelector(CompanySaleOderDetailsSelector)
    const [loadData, setLoadData] = useState({ FrDate: moment(moment(bfFrmDate)).add(-7, 'days').format('yyyy/MM/DD'), ToDate: moment(moment(bfFrmDate)).add(-1, 'days').format('yyyy/MM/DD'), CardCode: "", IsCommission: 0, IsSO: 1, IsPivotSlpNameByDocdate: 0, TimeType: "week" })
    const [loadDataBySlpName, setloadDataBySlpName] = useState({ FrDate: moment(moment(bfFrmDate)).add(-7, 'days').format('yyyy/MM/DD'), ToDate: moment(moment(bfFrmDate)).add(-1, 'days').format('yyyy/MM/DD'), CardCode: "", IsCommission: 0, IsSO: 1, IsPivotSlpNameByDocdate: 1, TimeType: "week" })
    const [selectedTimeType, setselectedTimeType] = useState('week')


    const PickerWithType = ({ type, onChange }) => {
        if (type === 'date') return <DatePicker onChange={onChange} />;
        if (type === 'RangePicker') return <RangePicker format={'DD/MM/yyyy'} onChange={onChange} defaultValue={[moment(loadData.FrDate), moment(loadData.ToDate)]} />;
        if (type === 'week') return <DatePicker format={customWeekStartEndFormat} onChange={onChange} picker="week" defaultValue={moment(loadData.FrDate)} />;
        if (type === 'year') return <DatePicker onChange={onChange} picker="year" defaultValue={moment(loadData.FrDate, 'YYYY')} />;
        if (type === 'month') return <DatePicker onChange={onChange} picker="month" defaultValue={moment(loadData.FrDate, 'YYYY/MM')} />;
        return <DatePicker picker={type} onChange={onChange} defaultValue={moment(loadData.FrDate)} />;
    };
    const dateChange = (date, datestring) => {
        if (date) {
            if (selectedTimeType === 'RangePicker') {
                setLoadData({ ...loadData, FrDate: date[0].format('yyyy/MM/DD'), ToDate: date[1].format('yyyy/MM/DD'), TimeType: selectedTimeType })
                setloadDataBySlpName({ ...loadDataBySlpName, FrDate: date[0].format('yyyy/MM/DD'), ToDate: date[1].format('yyyy/MM/DD'), TimeType: selectedTimeType })
            }
            else if (selectedTimeType === 'week') {
                const startDate = moment(date).startOf('week').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('week').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })

            }
            else if (selectedTimeType === 'month') {
                const startDate = moment(date).startOf('month').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('month').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            }
            else if (selectedTimeType === 'year') {
                const startDate = moment(date).startOf('year').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('year').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            }
            else if (selectedTimeType === 'quarter') {
                const startDate = moment(date).startOf('quarter').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('quarter').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
                setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            }
        }
    }
    const handleChange = (value) => {
        setselectedTimeType(value)
        
    };
    useEffect(() => {
        dispatch(getCompanySaleOderDetails(loadData))
    }, [loadData])
    useEffect(() => {
        dispatch(getSalesByEmployeeGroupByDate(loadDataBySlpName))
    }, [loadDataBySlpName])
    useEffect(() => {
        if (selectedTimeType === 'RangePicker') {
        }
        else if (selectedTimeType === 'week') {
            const startDate = moment(moment(bfFrmDate)).add(-7, 'days').format('yyyy/MM/DD')
            const endDate = moment(moment(bfFrmDate)).add(-1, 'days').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate , TimeType: selectedTimeType})
            setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
        else if (selectedTimeType === 'month') {
            const startDate = moment().startOf('month').format('yyyy/MM/DD')
            const endDate = moment().endOf('month').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
        else if (selectedTimeType === 'year') {
            const startDate = moment().startOf('year').format('yyyy/MM/DD')
            const endDate = moment().endOf('year').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate , TimeType: selectedTimeType})
            setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
        else if (selectedTimeType === 'quarter') {
            const startDate = moment().startOf('quarter').format('yyyy/MM/DD')
            const endDate = moment().endOf('quarter').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
            setloadDataBySlpName({ ...loadDataBySlpName, FrDate: startDate, ToDate: endDate, TimeType: selectedTimeType })
        }
    }, [selectedTimeType])
    return (
        <>
            <Space style={{marginBottom: '16px'}}>
                <Select defaultValue={selectedTimeType} style={{ width: 250 }} onChange={handleChange}>
                    {TimeDataSelNotFromTo.map((TimeDataSel, index) => (
                        <Option key={index} value={TimeDataSel.val}>{TimeDataSel.displayvalue}</Option>
                    ))}
                </Select>
                <PickerWithType type={selectedTimeType} onChange={dateChange} defaultValue={loadData.FrDate} />
            </Space>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={16} xl={15} xxl={14}>
                    <WeeklyRevenue pfrmDate={loadData.FrDate} ptoDate={loadData.ToDate} />
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={9} xxl={10}>
                    <DisplayDataSet />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={12} xxl={6}>
                    <Card title="Top 5 nhãn hàng có sản lượng cao">
                        <List
                            itemLayout="horizontal"
                            dataSource={CompanySaleOderDetailsSelectors.Top5QtyByPro4}
                            renderItem={item => (
                                <List.Item>
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <div>
                                            <h4 className="font-weight-bold mb-0">{item.U_Pro_4}</h4>
                                            <span className="text-muted">{item.Percent.toFixed(2)}%</span>
                                        </div>
                                        <div>
                                            <Tag color="blue">
                                                <span className="font-weight-bold">
                                                    <NumberFormat value={item.val.toFixed(2)} thousandSeparator={true} displayType="text" ></NumberFormat> (Kg)
                                                </span>
                                            </Tag>
                                        </div>
                                    </div>
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={7} >
                    <PieChart
                        id="pie"
                        type="doughnut"
                        title="Sản lượng theo loại giấy"
                        palette="Soft Pastel"
                        dataSource={CompanySaleOderDetailsSelectors.QtyByPro2}
                    >
                        <Series argumentField="U_Pro_2">
                            <Label visible={true} format="###,###,###">
                                <Connector visible={true} />
                            </Label>
                        </Series>
                        <Export enabled={false} />
                        <Legend
                            margin={0}
                            horizontalAlignment="center"
                            verticalAlignment="bottom"
                        />
                        <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                            <Format type="###,###,###" />
                        </Tooltip>
                    </PieChart>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8} >
                    <Chart
                        id="chart"
                        dataSource={CompanySaleOderDetailsSelectors.SalesByEmployeeGroupByDate}
                    >
                        <CommonSeriesSettings
                            argumentField="DocDate"
                            type='stackedBar'
                        />
                        {
                            CompanySaleOderDetailsSelectors.energySources.map((item, i) => <Series

                                key={item}
                                valueField={item}
                                name={item} />)
                        }
                        <Title text="Top 5 nhân viên có doanh thu cao nhất">
                        </Title>
                        <Legend verticalAlignment="top"
                            horizontalAlignment="center"
                            itemTextPosition="right"
                        />
                        <Tooltip enabled={true} customizeTooltip={customizeTooltipBarChart}>
                            <Format type="###,###,###" />
                        </Tooltip>

                    </Chart>
                </Col>
            </Row>
        </>
    );
    function customizeTooltip(pointInfo) {
        return {
            text: `${pointInfo.valueText} - ${(pointInfo.percent * 100).toFixed(2)}%`,
        };
    }
    function customizeTooltipBarChart(pointInfo) {
        return {
            text: `${selectedTimeType === 'year' ? 'Tháng': (selectedTimeType === 'quarter' ? 'Tuần' : 'Ngày') } ${pointInfo.argument} ${selectedTimeType === 'quarter'? moment().day("Sunday").week(pointInfo.argument).format('DD/MM') + '-' + moment().day("Sunday").week(pointInfo.argument).endOf('week').format('DD/MM'):''} <br/> <br/> ${pointInfo.valueText} <br/> <br/> ${pointInfo.seriesName} - ${(pointInfo.percent * 100).toFixed(2)}%`,
        };
    }

}

export default CompanySaleOderDetails;